module.exports = __webpack_public_path__ + "img/31.62d1dd31.png";